import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {}
};

export const adminDetails = createSlice({
  name: "admin-details",
  initialState: initialState,
  reducers: {
    data: (state, action) => {
      state.data = action.payload
    }
  },
});

export const { data } = adminDetails.actions;

export default adminDetails.reducer;
